import jquery from 'jquery';
import 'summernote';

export default window.$ = window.jQuery = jquery;
